// export const SET_DRAWER = 'drawer:set'
// export const CLEAR_DRAWER = 'drawer:clear'
export const UPDATE_APP_STATE = 'app:state:update'
